import { createModuleLogger } from '../utils/logger';

export const useLogger = (moduleName: string, context?: unknown) =>
  createModuleLogger(moduleName, context);
